import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-dotted-edges',
  templateUrl: './card-dotted-edges.component.html',
  styleUrls: ['./card-dotted-edges.component.scss']
})
export class CardDottedEdgesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
